(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/quick-bets/assets/javascripts/skeleton-loader.js') >= 0) return;  svs.modules.push('/components/oddset/quick-bets/assets/javascripts/skeleton-loader.js');
"use strict";


const Brand = svs.ui.ReactBrand;
const {
  Skeleton,
  SkeletonLine
} = svs.components.lbUi;
const {
  BetOfferTypeId
} = svs.components.oddset.kambiOffering.common.constants;
const getSectionOutcomes = betOfferType => {
  switch (betOfferType) {
    case BetOfferTypeId.OverUnder:
      return {
        outcomes: 2,
        offers: 4
      };
    case BetOfferTypeId.YesNo:
      return {
        outcomes: 2,
        offers: 1
      };
    case BetOfferTypeId.Match:
    default:
      return {
        outcomes: 3,
        offers: 1
      };
  }
};
const SkeletonLoader = _ref => {
  let {
    className,
    sections
  } = _ref;
  return React.createElement("section", {
    className: ['quick-bets', className].join(' ')
  }, React.createElement(Brand, {
    brand: "oddset-inverted",
    className: "quick-bets__oddset-logo",
    emblem: true,
    size: 100
  }), React.createElement("h2", {
    className: "quick-bets__header"
  }, "Matchen \xE4r tillg\xE4nglig p\xE5 Oddset"), sections.map(section => {
    const {
      offers,
      outcomes
    } = getSectionOutcomes(section.betOfferType);
    const offersArr = Array.from(Array(offers).keys());
    const outcomesArr = Array.from(Array(outcomes).keys());
    return React.createElement("section", {
      className: "quick-bet-section",
      key: section.englishLabel
    }, React.createElement(SkeletonLine, {
      className: "quick-bet-section__header",
      style: {
        width: '50%'
      }
    }), offersArr.map(offer => React.createElement("div", {
      className: "quick-bet-section-offer",
      key: offer
    }, outcomesArr.map((outcome, j) => React.createElement(Skeleton, {
      className: "outcome-btn",
      height: 2,
      key: "".concat(outcome, "-").concat(j)
    })))));
  }));
};
setGlobal('svs.components.oddset.quickBets.SkeletonLoader', SkeletonLoader);

 })(window);